import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Input,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import Dash from "../../components/Dash/Dash";
import "./contactUsV2.scss";
import {
  bg,
  cfb,
  cinstagram,
  clinkedin,
  coloredArrow,
  cyoutube,
  emailImg,
  location,
  UploadIcon,
} from "../../images";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";
import PhoneInput, {
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from "react-phone-number-input";
import Joi from "joi";
import axios from "axios";
import Thankyou from "../../components/Thankyou/Thankyou";
import moment from "moment/moment";
import dayjs from "dayjs";

const ContactUsV2 = () => {
  const countryCode = useRef();
  const [selected, setSelected] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState();
  const [countries, setCountries] = useState([]);
  const [selectedCode, setSelectedCode] = useState("+91");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalThankyouOpen, setThankyouModalIsOpen] = useState(false);
  const [phoneCodeToCountry, setPhoneCodeToCountry] = useState({});
  const [cvFile, setCvFile] = useState(null);
  const [cvFileName, setCvFileName] = useState("");

  const resumeFileInputRef = useRef(null);
  const ResumeUploadClick = () => {
    resumeFileInputRef.current.click();
  };

  const handleCvUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    const maxSize = 5 * 1024 * 1024;

    // Invalid type
    if (!allowedTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        cvFile: "Only PDF, DOC, or DOCX files are allowed!",
      }));
      e.target.value = "";
      setCvFile(null);
      setCvFileName("");
      return;
    }

    // Invalid size
    if (file.size > maxSize) {
      setErrors((prev) => ({
        ...prev,
        cvFile: "File size cannot exceed 5 MB!",
      }));
      e.target.value = "";
      setCvFile(null);
      setCvFileName("");
      return;
    }

    setCvFile(file);
    setCvFileName(file.name);

    // Valid file
    setErrors((prev) => ({
      ...prev,
      cvFile: "",
    }));
  };

  useEffect(() => {
    const flagBtn = countryCode.current?.querySelector("select");
    if (!flagBtn) return;
    console.log(flagBtn);

    const handleClick = (e) => !flagBtn.contains(e.target) && flagBtn.focus();
    countryCode.current.addEventListener("click", handleClick);
    return () => countryCode.current.removeEventListener("click", handleClick);
  }, []);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",

    phone: "",
    company: "",
    country: "",
    letUsKnowMore: "",
    bestDescribes: "",
    pleaseSpecify: "",
    inquiryType: "Within",
    landlineNo: "",
    city: "",
    state: "",
    productInquiryType: [],
    zipCode: "",
    whoShouldContact: "",
    contactPersonName: "",
    contactPersonMobile: "",
    contactPersonEmail: "",
    bestTimeDate: "",
    bestTimeTime: "",
    raiseRequestFor: [],
    preferredContact: ["Phone Call"],
    endUseOfYarn: [],
    quantity: "",
    purchaseTimeline: "",
    remarks: "",
    bestDescribesOthers: "",
    productInquiryTypeOthers: "",
    endUseOfYarnOthers: "",
  });

  const [errors, setErrors] = useState({});

  const validationSchema = Joi.object({
    firstName: Joi.string().trim().required().messages({
      "string.empty": "First Name is required",
    }),
    lastName: Joi.string().trim().required().messages({
      "string.empty": "Last Name is required",
    }),
    email: Joi.string()
      .trim()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.email": "Please enter a valid email",
        "string.empty": "Email is required",
      }),
    phone: Joi.string()
      .trim()
      .pattern(/^\d+$/)
      .when("selectedCode", {
        is: "+91",
        then: Joi.string().length(10).messages({
          "string.length": "Phone number must be 10 digits",
        }),
        otherwise: Joi.string().messages({}),
      })
      .required()
      .messages({
        "string.empty": "Phone number is required",
        "string.pattern.base": "Phone number must contain only digits",
      }),

    cvFile: Joi.any().when("letUsKnowMore", {
      is: "HR enquiry",
      then: Joi.any().required().messages({
        "any.required": "Resume is required for HR enquiry",
      }),
      otherwise: Joi.any().allow(null).optional(),
    }),

    company: Joi.string()
      .trim()
      .when("bestDescribes", {
        is: "Agent/Dealer/Trader",
        then: Joi.string().allow("").optional(),
        otherwise: Joi.string().required().messages({
          "string.empty": "Company is required",
        }),
      }),
    // country: Joi.string().when("letUsKnowMore", {
    //   is: "Product enquiry",
    //   then: Joi.string().trim().required().messages({
    //     "string.empty": "Country is required",
    //   }),
    //   otherwise: Joi.string().allow(""),
    // }),
    country: Joi.when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.when("inquiryType", {
        is: "Outside",
        then: Joi.string().trim().required().messages({
          "string.empty": "Country is required",
        }),
        otherwise: Joi.string().allow("").optional(),
      }),
      otherwise: Joi.string().allow("").optional(),
    }),
    landlineNo: Joi.string().when("inquiryType", {
      is: "Within",
      then: Joi.string()
        .allow("")
        .optional()
        .pattern(/^\d+$/) // only digits
        .max(11) // max 11 digits
        .messages({
          "string.pattern.base": "Landline number must contain only digits",
          "string.max": "Landline number must be at most 11 digits long",
        }),
      otherwise: Joi.string().allow("").pattern(/^\d+$/).max(11).messages({
        "string.pattern.base": "Landline number must contain only digits",
        "string.max": "Landline number must be at most 11 digits long",
      }),
    }),
    city: Joi.string().when("inquiryType", {
      is: "Within",
      then: Joi.string().required().messages({
        "string.empty": "City is required",
      }),
      otherwise: Joi.string().allow(""),
    }),
    state: Joi.string().when("inquiryType", {
      is: "Within",
      then: Joi.string().required().messages({
        "string.empty": "State is required",
      }),
      otherwise: Joi.string().allow(""),
    }),
    bestTimeDate: Joi.when("whoShouldContact", {
      is: Joi.valid("Myself", "Someone Else"),
      then: Joi.string().required().messages({
        "string.empty": "Date is required",
      }),
      otherwise: Joi.string().allow(""),
    }),
    bestTimeTime: Joi.when("whoShouldContact", {
      is: Joi.valid("Myself", "Someone Else"),
      then: Joi.string().required().messages({
        "string.empty": "Time is required",
      }),
      otherwise: Joi.string().allow(""),
    }),

    remarks: Joi.string().allow(""),
    letUsKnowMore: Joi.string().required().messages({
      "string.empty": "This field is required",
    }),
    bestDescribes: Joi.string().when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.string().required().messages({
        "string.empty": "This field is required",
      }),
      otherwise: Joi.string().allow(""),
    }),
    inquiryType: Joi.string().when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.string().required().messages({
        "string.empty": "Inquiry type is required",
      }),
      otherwise: Joi.string().allow(""),
    }),
    productInquiryType: Joi.array().when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.array().items(Joi.string()).min(1).required().messages({
        "array.min": "At least one product inquiry type is required",
        "array.base": "Product inquiry type is required",
      }),
      otherwise: Joi.array().items(Joi.string()).default([]),
    }),
    zipCode: Joi.string().when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.string().required().messages({
        "string.empty": "Postal Code is required",
      }),
      otherwise: Joi.string().allow(""),
    }),
    whoShouldContact: Joi.string().when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.string().required().messages({
        "string.empty": "Who should we contact is required",
      }),
      otherwise: Joi.string().allow(""),
    }),
    raiseRequestFor: Joi.array().when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.array().items(Joi.string()).min(1).required().messages({
        "array.min": "At least one request type is required",
        "array.base": "Raise request for is required",
      }),
      otherwise: Joi.array().items(Joi.string()).default([]),
    }),
    preferredContact: Joi.array().when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.array().items(Joi.string()).min(1).required().messages({
        "array.min": "At least one preferred contact mode is required",
        "array.base": "Preferred contact mode is required",
      }),
      otherwise: Joi.array().items(Joi.string()).default([]),
    }),
    endUseOfYarn: Joi.array().when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.array().items(Joi.string()).min(1).required().messages({
        "array.min": "At least one end use of yarn is required",
        "array.base": "End use of yarn is required",
      }),
      otherwise: Joi.array().items(Joi.string()).default([]),
    }),
    quantity: Joi.number().when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.number().required().messages({
        "any.required": "Quantity is required",
        "number.base": "Quantity must be a number",
        // "number.integer": "Quantity must be an integer",
      }),
      otherwise: Joi.number().allow("", null),
    }),
    purchaseTimeline: Joi.string().when("letUsKnowMore", {
      is: "Product enquiry",
      then: Joi.string().required().messages({
        "string.empty": "Purchase timeline is required",
      }),
      otherwise: Joi.string().allow(""),
    }),
    pleaseSpecify: Joi.string().when("letUsKnowMore", {
      is: "Other enquiry",
      then: Joi.string().required().messages({
        "string.empty": "This is required",
      }),
      // otherwise: Joi.string().when("bestDescribes", {
      //   is: "Other",
      //   then: Joi.string().required().messages({
      //     "string.empty": "This is required",
      //   }),
      // }),
      otherwise: Joi.string().allow(""),
    }),
    bestDescribesOthers: Joi.string().when("bestDescribes", {
      is: "Other",
      then: Joi.string().required().messages({
        "string.empty": "This is required",
      }),
      otherwise: Joi.string().allow(""),
    }),

    productInquiryTypeOthers: Joi.string().when("productInquiryType", {
      is: Joi.array().items(Joi.string()).has(Joi.string().valid("Other")),
      then: Joi.string().required().messages({
        "string.empty": "This is required",
      }),
      otherwise: Joi.string().allow(""),
    }),

    endUseOfYarnOthers: Joi.string().when("endUseOfYarn", {
      is: Joi.array().items(Joi.string()).has(Joi.string().valid("Other")),
      then: Joi.string().required().messages({
        "string.empty": "This is required",
      }),
      otherwise: Joi.string().allow(""),
    }),
    contactPersonName: Joi.string().when("whoShouldContact", {
      is: "Someone Else",
      then: Joi.string().required().messages({
        "string.empty": "Contact person name is required",
      }),
      otherwise: Joi.string().allow(""),
    }),
    contactPersonMobile: Joi.string().when("whoShouldContact", {
      is: "Someone Else",
      then: Joi.string().pattern(/^\d+$/).required().messages({
        "string.empty": "Contact person mobile is required",
        "string.pattern.base": "Contact person mobile must contain only digits",
      }),
      otherwise: Joi.string().allow(""),
    }),
    contactPersonEmail: Joi.string().when("whoShouldContact", {
      is: "Someone Else",
      then: Joi.string()
        .email({ tlds: { allow: false } })
        .required()
        .messages({
          "string.email": "Please enter a valid email",
          "string.empty": "Contact person email is required",
        }),
      otherwise: Joi.string().allow(""),
    }),
  }).options({ allowUnknown: true });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const handleArrayChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const validateForm = () => {
    const { error } = validationSchema.validate(
      {
        ...formData,
        selectedCode,
        cvFile,
      },
      { abortEarly: false },
    );

    if (error) {
      const newErrors = {};
      error.details.forEach((detail) => {
        newErrors[detail.path[0]] = detail.message;
      });
      setErrors(newErrors);
      return false;
    }

    setErrors({});
    return true;
  };

  const formatDateTime = (date, time) => {
    console.log({ date, time });
    if (!date || !time) return null;

    // const m = moment.utc(`${date} ${time}`, "YYYY-MM-DD HH:mm");

    // Add IST offset (+05:30)
    // const formatted = m.utcOffset("+05:30").format("YYYY-MM-DDTHH:mm:ssZ");
    const formatted = moment(`${date}T${time}:00+05:30`).format();
    return formatted;
  };

  const toggleThankyouModal = () => {
    setThankyouModalIsOpen(!isModalThankyouOpen);
  };

  const handleResetForm = () => {
    console.log(formData);
    setFormData({
      firstName: "",
      lastName: "",
      email: "",

      phone: "",
      company: "",
      country: "",
      letUsKnowMore: "",
      bestDescribes: "",
      pleaseSpecify: "",
      inquiryType: "",
      landlineNo: "",
      city: "",
      state: "",
      productInquiryType: [],
      zipCode: "",
      whoShouldContact: "",
      contactPersonName: "",
      contactPersonMobile: "",
      contactPersonEmail: "",
      bestTimeDate: "",
      bestTimeTime: "",
      raiseRequestFor: [],
      preferredContact: ["Phone Call"],
      endUseOfYarn: [],
      quantity: "",
      purchaseTimeline: "",
      remarks: "",
    });
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (formData.inquiryType === "Within") {
    //   formData.country = "India";
    // }
    if (!validateForm()) {
      return;
      // Submit form data to Zoho API
    }
    if (formData.letUsKnowMore === "HR enquiry" && !cvFile) {
      setErrors((prev) => ({
        ...prev,
        cvFile: "Resume is required for HR enquiry",
      }));
      return;
    }

    setIsSubmitting(true);
    try {
      const bestTimeDateTime = formatDateTime(
        formData.bestTimeDate,
        formData.bestTimeTime,
      );

      // Prepare data for submission
      // Ensure country is always set
      const submissionData = {
        ...formData,
        phone: formData.phone,
        countryCode: selectedCode || "+91",
        country:
          formData.inquiryType === "Within" ? "India" : formData.country || "",
      };

      if (!formData.country && formData.countryCode === "+91") {
        formData.country = "India";
      }

      if (submissionData.inquiryType === "Within") {
        submissionData.inquiryType = "Within India";
      } else if (submissionData.inquiryType === "Outside") {
        submissionData.inquiryType = "Outside India";
      }

      if (formData.letUsKnowMore !== "Product enquiry") {
        submissionData.inquiryType = "";
        submissionData.preferredContact = [];
      }

      if (formData.whoShouldContact === "Myself" && bestTimeDateTime) {
        submissionData.best_time_to_connect_with_you = bestTimeDateTime;
      } else if (
        formData.whoShouldContact === "Someone Else" &&
        bestTimeDateTime
      ) {
        submissionData.best_time_to_connect_with_yourself = bestTimeDateTime;
      }

      delete submissionData.bestTimeDate;
      delete submissionData.bestTimeTime;

      const formDataToSend = new FormData();

      Object.keys(submissionData).forEach((key) => {
        if (submissionData[key] === "None") {
          submissionData[key] = "";
        }

        const value = submissionData[key];

        // if (Array.isArray(value)) {
        //   value.forEach((v) => formDataToSend.append(key, v));
        // } else {
        //   // append everything, even empty string
        //   formDataToSend.append(
        //     key,
        //     value !== undefined && value !== null ? value : "",
        //   );
        // }
        if (Array.isArray(value)) {
          value.forEach((v) => formDataToSend.append(`${key}[]`, v));
        } else {
          formDataToSend.append(key, value ?? "");
        }
      });

      if (cvFile) {
        formDataToSend.append("resume", cvFile);
      }

      console.log(formDataToSend);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/contact/zoho-post-leads`,
        formDataToSend,
      );
      console.log(response.data.status);
      if (response.data.status === 200) {
        // alert("Form submitted successfully!");
        // Reset form
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          company: "",
          country: "",
          letUsKnowMore: "",
          bestDescribes: "",
          pleaseSpecify: "",
          inquiryType: "",
          landlineNo: "",
          city: "",
          state: "",
          productInquiryType: [],
          zipCode: "",
          whoShouldContact: "",
          contactPersonName: "",
          contactPersonMobile: "",
          contactPersonEmail: "",
          bestTimeDate: "",
          bestTimeTime: "",
          raiseRequestFor: [],
          preferredContact: [],
          endUseOfYarn: [],
          quantity: "",
          purchaseTimeline: "",
          remarks: "",
        });
        toggleThankyouModal();

        window.scroll(0, 0);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const showBuyingProductFields = () =>
    formData.letUsKnowMore === "Product enquiry";
  const showOtherSpecifyField = () =>
    formData.letUsKnowMore === "Other enquiry";
  // ||    formData.bestDescribes === "Other";
  const showWithinIndiaFields = () => formData.inquiryType === "Within";
  const showSomeoneElseFields = () =>
    formData.whoShouldContact === "Someone Else";
  const showBestTimeField = () =>
    formData.whoShouldContact === "Myself" ||
    formData.whoShouldContact === "Someone Else";

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelected(typeof value === "string" ? value.split(",") : value);
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/general/countries`,
        );
        setCountries(response?.data?.data);
        const phoneCodeMap = {};
        response?.data?.data.forEach((country) => {
          if (country.phonecode) {
            phoneCodeMap[country.phonecode] = country.name;
          }
        });
        setPhoneCodeToCountry(phoneCodeMap);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (selectedCode) {
      const numericCode = selectedCode.replace("+", "");
      if (numericCode !== "91") {
        let countryName = phoneCodeToCountry[numericCode] || "";
        if (numericCode === "1") {
          countryName = "United States";
        }
        setFormData((prev) => ({
          ...prev,
          inquiryType: "Outside",
          country: countryName,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          inquiryType: "Within",
          country: "India",
        }));
      }
    }
  }, [selectedCode, phoneCodeToCountry, formData.letUsKnowMore]);

  useEffect(() => {
    if (formData.letUsKnowMore === "Product enquiry") {
      if (selectedCode) {
        const numericCode = selectedCode.replace("+", "");
        if (numericCode !== "91") {
          setFormData((prev) => ({
            ...prev,
            inquiryType: "Outside",
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            inquiryType: "Within",
          }));
        }
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        inquiryType: "",
      }));
    }
  }, [formData.letUsKnowMore]);

  useEffect(() => {
    if (formData.letUsKnowMore !== "HR enquiry") {
      setCvFile(null);
      setCvFileName("");
      if (resumeFileInputRef.current) {
        resumeFileInputRef.current.value = "";
      }
      setErrors((prev) => ({ ...prev, cvFile: "" }));
    }
  }, [formData.letUsKnowMore]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const now = new Date();
  const currentTime = now.toTimeString().slice(0, 5);
  const today = dayjs().format("YYYY-MM-DD");
  return (
    <>
      <MetaDecorator
        // noIndex={true}
        canonicalLink="https://www.sanathan.com/contact-us"
        metaTitle="Contact Us | Sanathan Textiles"
        metaDesc="Fill in the contact form or mail us at sales@sanathan.com for business queries. We will get back at the earliest."
      />
      {isModalThankyouOpen && <Thankyou onRequestClose={toggleThankyouModal} />}
      <section id="contactUs_v2" data-aos="fade-in">
        <div className="wrapper">
          <div className="breadcrumb_styles">
            <Link to="/" className="breadcrumb_link">
              Home
            </Link>{" "}
            {">"} Contact Us
          </div>
          <div className="contact_container">
            <div className="left">
              <h1 className="hollow_title">Contact Us</h1>
              <div className="dash_wrapper">
                <Dash />
              </div>
              <h3>Say hello to us!</h3>

              <div className="form_wrapper">
                <form onSubmit={handleSubmit}>
                  <div
                    className={`grid_form ${
                      !errors || Object.keys(errors).length === 0
                        ? ``
                        : `errSpace`
                    }`}
                  >
                    <div className="form-group ">
                      <TextField
                        type="text"
                        name="first_name"
                        label="First Name*"
                        value={formData.firstName}
                        onChange={(e) =>
                          handleInputChange("firstName", e.target.value)
                        }
                        error={!!errors.firstName}
                      />
                      {errors.firstName && (
                        <div className="err">{errors.firstName}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <TextField
                        type="text"
                        name="last_name"
                        label="Last Name*"
                        value={formData.lastName}
                        onChange={(e) =>
                          handleInputChange("lastName", e.target.value)
                        }
                        error={!!errors.lastName}
                      />
                      {errors.lastName && (
                        <div className="err">{errors.lastName}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <TextField
                        type="email"
                        name="email"
                        label="Email Id*"
                        value={formData.email}
                        onChange={(e) =>
                          handleInputChange("email", e.target.value)
                        }
                        error={!!errors.email}
                      />
                      {errors.email && (
                        <div className="err">{errors.email}</div>
                      )}
                    </div>

                    {/* Phone Input */}
                    <div className="form-group">
                      <div className="phone_input">
                        <PhoneInput
                          ref={countryCode}
                          className="phoneMui"
                          style={{ backgroundColor: "white" }}
                          defaultCountry="IN"
                          placeholder="Phone"
                          international
                          countryCallingCodeEditable={false}
                          value={selectedCode}
                          onChange={setSelectedCode}
                          // disabled
                        />
                        {/* <Select
                        MenuProps={{
                          disableScrollLock: true, //  fixes the header shift + scrollbar hide
                        }}
                      >
                        <MenuItem value={91}>India</MenuItem>
                      </Select> */}
                        <TextField
                          inputProps={{
                            inputMode: "numeric",
                          }}
                          className="phone_input_field"
                          type="text"
                          name="phone"
                          label="Phone*"
                          value={formData.phone}
                          onChange={(e) =>
                            handleInputChange("phone", e.target.value)
                          }
                          error={!!errors.phone}
                        />
                      </div>
                      {errors.phone && (
                        <div className="err">{errors.phone}</div>
                      )}
                      {/* <div className="err">This field is required</div> */}
                    </div>

                    <div className="form-group">
                      <TextField
                        type="text"
                        name="company"
                        label={
                          formData.bestDescribes === "Agent/Dealer/Trader"
                            ? "Company"
                            : "Company*"
                        }
                        value={formData.company}
                        onChange={(e) =>
                          handleInputChange("company", e.target.value)
                        }
                        error={!!errors.company}
                      />
                      {errors.company && (
                        <div className="err">{errors.company}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <FormControl>
                        <InputLabel id="let_us_know_more_about_u">
                          Let us know more about you*
                        </InputLabel>
                        <Select
                          labelId="let_us_know_more_about_u"
                          label="Let us know more about you"
                          className="select_input"
                          MenuProps={{
                            disableScrollLock: true, //  fixes the header shift + scrollbar hide
                          }}
                          value={formData.letUsKnowMore}
                          onChange={(e) =>
                            handleInputChange("letUsKnowMore", e.target.value)
                          }
                        >
                          {/* <MenuItem value="None">None</MenuItem> */}
                          <MenuItem value="Product enquiry">
                            Product enquiry
                          </MenuItem>
                          <MenuItem value="Investor">Investor</MenuItem>
                          <MenuItem value="Media/PR">Media/PR</MenuItem>
                          <MenuItem value="HR enquiry">HR enquiry</MenuItem>
                          <MenuItem value="Other enquiry">
                            Other enquiry
                          </MenuItem>
                        </Select>
                      </FormControl>
                      {errors.letUsKnowMore && (
                        <div className="err">{errors.letUsKnowMore}</div>
                      )}
                    </div>

                    {/* condition->Interested in buying product */}
                    {showBuyingProductFields() && (
                      <>
                        <div
                          className={`form-group ${
                            formData.bestDescribes === "Other"
                              ? ``
                              : `full_width`
                          } `}
                        >
                          <FormControl>
                            <InputLabel id="choose_the_option_that_best_describes_you">
                              Choose the option that best describes you*
                            </InputLabel>
                            <Select
                              labelId="choose_the_option_that_best_describes_you"
                              label="Choose the option that best describes you"
                              className="select_input"
                              value={formData.bestDescribes}
                              onChange={(e) => {
                                const value = e.target.value;

                                handleInputChange("bestDescribes", value);
                              }}
                              error={!!errors.bestDescribes}
                            >
                              {/* <MenuItem value="None">None</MenuItem> */}
                              <MenuItem value="Agent/Dealer/Trader">
                                Agent/Dealer/Trader
                              </MenuItem>
                              <MenuItem value="Buying House">
                                Buying House
                              </MenuItem>
                              <MenuItem value="Manufacturer">
                                Manufacturer
                              </MenuItem>
                              <MenuItem value="Service provider">
                                Service provider
                              </MenuItem>
                              <MenuItem value="Other">Other</MenuItem>
                            </Select>
                            {/* <div className="form-group full_width">
                                <TextField
                                  type="text"
                                  label="Please Specify (Best Describes)*"
                                  value={formData.bestDescribesOthers}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "bestDescribesOthers",
                                      e.target.value
                                    )
                                  }
                                  error={!!errors.bestDescribesOthers}
                                />
                                {errors.bestDescribesOthers && (
                                  <div className="err">
                                    {errors.bestDescribesOthers}
                                  </div>
                                )}
                              </div> */}
                          </FormControl>
                          {errors.bestDescribes && (
                            <div className="err">{errors.bestDescribes}</div>
                          )}
                        </div>
                        {formData.bestDescribes === "Other" && (
                          <div
                            className={`form-group ${
                              formData.bestDescribes === "Other"
                                ? ``
                                : `full_width`
                            } `}
                          >
                            <TextField
                              type="text"
                              label="Please Specify*"
                              value={formData.bestDescribesOthers}
                              onChange={(e) =>
                                handleInputChange(
                                  "bestDescribesOthers",
                                  e.target.value,
                                )
                              }
                              error={!!errors.bestDescribesOthers}
                            />
                            {errors.bestDescribesOthers && (
                              <div className="err">
                                {errors.bestDescribesOthers}
                              </div>
                            )}
                          </div>
                        )}
                        <div className="form-group full_width">
                          <FormControl>
                            <FormLabel id="demo-row-radio-buttons-group-label">
                              Inquiry type*
                            </FormLabel>
                            <RadioGroup
                              row
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              name="row-radio-buttons-group"
                              value={formData.inquiryType}
                              onChange={(e) =>
                                handleInputChange("inquiryType", e.target.value)
                              }
                            >
                              <FormControlLabel
                                value="Within"
                                control={<Radio size="small" />}
                                label="Within India"
                              />
                              <FormControlLabel
                                value="Outside"
                                control={<Radio size="small" />}
                                label="Outside India"
                              />
                            </RadioGroup>
                          </FormControl>
                          {errors.inquiryType && (
                            <div className="err">{errors.inquiryType}</div>
                          )}
                        </div>
                        {!showWithinIndiaFields() && (
                          <div className="form-group">
                            <FormControl>
                              <InputLabel>Country*</InputLabel>
                              <Select
                                label="Country*"
                                value={formData.country}
                                onChange={(e) =>
                                  handleInputChange("country", e.target.value)
                                }
                                error={!!errors.country}
                              >
                                {countries
                                  ?.filter?.(
                                    (country) => country.name !== "India",
                                  )
                                  ?.map((country) => (
                                    <MenuItem
                                      key={country.iso3}
                                      value={country.name}
                                    >
                                      {country.name}
                                    </MenuItem>
                                  )) || null}
                              </Select>
                            </FormControl>
                            {errors.country && (
                              <div className="err">{errors.country}</div>
                            )}
                          </div>
                        )}
                        {showWithinIndiaFields() && (
                          <>
                            <div className="form-group">
                              <TextField
                                type="text"
                                label="Landline No."
                                value={formData.landlineNo}
                                onChange={(e) =>
                                  handleInputChange(
                                    "landlineNo",
                                    e.target.value,
                                  )
                                }
                              />
                              {errors.landlineNo && (
                                <div className="err">{errors.landlineNo}</div>
                              )}
                            </div>
                            <div className="form-group">
                              <TextField
                                type="text"
                                label="City*"
                                value={formData.city}
                                onChange={(e) =>
                                  handleInputChange("city", e.target.value)
                                }
                              />
                              {errors.city && (
                                <div className="err">{errors.city}</div>
                              )}
                            </div>
                            <div className="form-group">
                              <TextField
                                type="text"
                                label="State*"
                                value={formData.state}
                                onChange={(e) =>
                                  handleInputChange("state", e.target.value)
                                }
                              />
                              {errors.state && (
                                <div className="err">{errors.state}</div>
                              )}
                            </div>
                          </>
                        )}
                        <div className="form-group">
                          <FormControl>
                            <InputLabel>Product inquiry type*</InputLabel>
                            <Select
                              multiple
                              label="Product inquiry type"
                              value={formData.productInquiryType}
                              onChange={(e) =>
                                handleArrayChange(
                                  "productInquiryType",
                                  e.target.value,
                                )
                              }
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {[
                                "Drawn Textured Yarn (DTY)",
                                "Fully Drawn Yarn (FDY)",
                                "Air Textured Yarn (ATY)",
                                "Industrial Drawn Yarn (IDY)",
                                "Cotton Yarn",
                                "Chips",
                                "Yarn Waste",
                                "Other",
                              ].map((name) => (
                                <MenuItem key={name} value={name}>
                                  <Checkbox
                                    checked={formData.productInquiryType.includes(
                                      name,
                                    )}
                                  />
                                  {name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {errors.productInquiryType && (
                            <div className="err">
                              {errors.productInquiryType}
                            </div>
                          )}
                        </div>
                        {formData.productInquiryType.includes("Other") && (
                          <div className="form-group">
                            <TextField
                              type="text"
                              label="Please Specify (Product Inquiry)*"
                              value={formData.productInquiryTypeOthers}
                              onChange={(e) =>
                                handleInputChange(
                                  "productInquiryTypeOthers",
                                  e.target.value,
                                )
                              }
                              error={!!errors.productInquiryTypeOthers}
                            />
                            {errors.productInquiryTypeOthers && (
                              <div className="err">
                                {errors.productInquiryTypeOthers}
                              </div>
                            )}
                          </div>
                        )}

                        <div className="form-group">
                          <TextField
                            inputProps={{
                              inputMode: "numeric",
                            }}
                            type="text"
                            label="Postal Code*"
                            value={formData.zipCode}
                            onChange={(e) =>
                              handleInputChange("zipCode", e.target.value)
                            }
                          />
                          {errors.zipCode && (
                            <div className="err">{errors.zipCode}</div>
                          )}
                        </div>

                        <div className="form-group">
                          <FormControl>
                            <InputLabel>Who should we contact?*</InputLabel>
                            <Select
                              label="Who should we contact?"
                              value={formData.whoShouldContact}
                              onChange={(e) =>
                                handleInputChange(
                                  "whoShouldContact",
                                  e.target.value,
                                )
                              }
                            >
                              <MenuItem value="Myself">Contact me</MenuItem>
                              {/* <MenuItem value="Other">Other</MenuItem> */}
                              <MenuItem value="Someone Else">
                                Contact someone else
                              </MenuItem>
                            </Select>
                          </FormControl>
                          {errors.whoShouldContact && (
                            <div className="err">{errors.whoShouldContact}</div>
                          )}
                        </div>
                        {showSomeoneElseFields() && (
                          <>
                            <div className="form-group">
                              <TextField
                                type="text"
                                label="Contact Person Name*"
                                value={formData.contactPersonName}
                                onChange={(e) =>
                                  handleInputChange(
                                    "contactPersonName",
                                    e.target.value,
                                  )
                                }
                                error={!!errors.contactPersonName}
                              />
                              {errors.contactPersonName && (
                                <div className="err">
                                  {errors.contactPersonName}
                                </div>
                              )}
                            </div>
                            <div className="form-group">
                              <TextField
                                type="text"
                                inputProps={{
                                  inputMode: "numeric",
                                }}
                                label="Contact Person Mobile*"
                                value={formData.contactPersonMobile}
                                onChange={(e) =>
                                  handleInputChange(
                                    "contactPersonMobile",
                                    e.target.value,
                                  )
                                }
                                error={!!errors.contactPersonMobile}
                              />
                              {errors.contactPersonMobile && (
                                <div className="err">
                                  {errors.contactPersonMobile}
                                </div>
                              )}
                            </div>
                            <div className="form-group">
                              <TextField
                                type="text"
                                label="Contact Person Email*"
                                value={formData.contactPersonEmail}
                                onChange={(e) =>
                                  handleInputChange(
                                    "contactPersonEmail",
                                    e.target.value,
                                  )
                                }
                                error={!!errors.contactPersonEmail}
                              />
                              {errors.contactPersonEmail && (
                                <div className="err">
                                  {errors.contactPersonEmail}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        {showBestTimeField() && (
                          <div className="form-group full_width">
                            <InputLabel>Best time to connect*</InputLabel>
                            <div className="date_time">
                              <div>
                                <TextField
                                  type="date"
                                  value={formData.bestTimeDate}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "bestTimeDate",
                                      e.target.value,
                                    )
                                  }
                                  inputProps={{
                                    min: dayjs().format("YYYY-MM-DD"),
                                    // min: new Date().toISOString().split("T")[0],
                                  }}
                                />
                                {errors.bestTimeDate && (
                                  <div className="err">
                                    {errors.bestTimeDate}
                                  </div>
                                )}
                              </div>
                              <div>
                                <TextField
                                  type="time"
                                  value={formData.bestTimeTime}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "bestTimeTime",
                                      e.target.value,
                                    )
                                  }
                                  inputProps={{
                                    min:
                                      formData.bestTimeDate === today
                                        ? currentTime
                                        : undefined,
                                  }}
                                />
                                {errors.bestTimeTime && (
                                  <div className="err">
                                    {errors.bestTimeTime}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="form-group">
                          <FormControl>
                            <InputLabel>Raise Request For*</InputLabel>
                            <Select
                              multiple
                              label="Raise Request For"
                              value={formData.raiseRequestFor}
                              onChange={(e) =>
                                handleArrayChange(
                                  "raiseRequestFor",
                                  e.target.value,
                                )
                              }
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {["Sample", "Information", "Meeting"].map(
                                (name) => (
                                  <MenuItem key={name} value={name}>
                                    <Checkbox
                                      checked={formData.raiseRequestFor.includes(
                                        name,
                                      )}
                                    />
                                    {name}
                                  </MenuItem>
                                ),
                              )}
                            </Select>
                          </FormControl>
                          {errors.raiseRequestFor && (
                            <div className="err">{errors.raiseRequestFor}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <FormControl>
                            <InputLabel>Preferred Mode of Contact</InputLabel>
                            <Select
                              multiple
                              label="Preferred Mode of Contact"
                              value={formData.preferredContact}
                              onChange={(e) =>
                                handleArrayChange(
                                  "preferredContact",
                                  e.target.value,
                                )
                              }
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {["Phone Call", "Email", "WhatsApp", "SMS"].map(
                                (name) => (
                                  <MenuItem key={name} value={name}>
                                    <Checkbox
                                      checked={formData.preferredContact.includes(
                                        name,
                                      )}
                                    />
                                    {name}
                                  </MenuItem>
                                ),
                              )}
                            </Select>
                          </FormControl>
                          {errors.preferredContact && (
                            <div className="err">{errors.preferredContact}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <FormControl>
                            <InputLabel>End use of yarn*</InputLabel>
                            <Select
                              multiple
                              label="End use of yarn"
                              value={formData.endUseOfYarn}
                              onChange={(e) =>
                                handleArrayChange(
                                  "endUseOfYarn",
                                  e.target.value,
                                )
                              }
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {[
                                "Circular Knitting",
                                "Warp Knitting",
                                "Weaving",
                                "Flat Knitting",
                                "Narrow Weaving",
                                "Seamless Knitting",
                                "Rachell Knitting",
                                "Embroidery Machines",
                                "Fancy Yarn Manufacturing",
                                "Yarn Dyeing",
                                "Twister",
                                "Crochet",
                                "Hand Tufting",
                                "Electronic Tufting",
                                "Rope Making",
                                "Fiber Manufacturing",
                                "DTY Manufacturer",
                                "FDY Manufacturer",
                                "ATY Manufacturer",
                                "IDY Manufacturer",
                                "Cotton Yarn Manufacturer",
                                "Other Circular Knitting",
                                "Other",
                              ].map((name) => (
                                <MenuItem key={name} value={name}>
                                  <Checkbox
                                    checked={formData.endUseOfYarn.includes(
                                      name,
                                    )}
                                  />
                                  {name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {errors.endUseOfYarn && (
                            <div className="err">{errors.endUseOfYarn}</div>
                          )}
                        </div>
                        {formData.endUseOfYarn.includes("Other") && (
                          <div className="form-group">
                            <TextField
                              type="text"
                              label="Please Specify (End Use)*"
                              value={formData.endUseOfYarnOthers}
                              onChange={(e) =>
                                handleInputChange(
                                  "endUseOfYarnOthers",
                                  e.target.value,
                                )
                              }
                              error={!!errors.endUseOfYarnOthers}
                            />
                            {errors.endUseOfYarnOthers && (
                              <div className="err">
                                {errors.endUseOfYarnOthers}
                              </div>
                            )}
                          </div>
                        )}
                        <div className="form-group">
                          <TextField
                            type="text"
                            label="Quantity Needed (in tons/month)*"
                            value={formData.quantity}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*\.?\d*$/.test(value)) {
                                handleInputChange("quantity", value);
                              }
                            }}
                          />
                          {errors.quantity && (
                            <div className="err">{errors.quantity}</div>
                          )}
                        </div>
                        <div className="form-group">
                          <FormControl>
                            <InputLabel>Expected Purchase Timeline*</InputLabel>
                            <Select
                              label="Expected Purchase Timeline"
                              value={formData.purchaseTimeline}
                              onChange={(e) =>
                                handleInputChange(
                                  "purchaseTimeline",
                                  e.target.value,
                                )
                              }
                            >
                              {/* <MenuItem value="None">None</MenuItem> */}
                              <MenuItem value="Immediate">Immediate</MenuItem>
                              <MenuItem value="1-3 Months">1-3 Months</MenuItem>
                              <MenuItem value=">3 Months">
                                {">3 Months"}
                              </MenuItem>
                            </Select>
                          </FormControl>
                          {errors.purchaseTimeline && (
                            <div className="err">{errors.purchaseTimeline}</div>
                          )}
                        </div>
                      </>
                    )}
                    {showOtherSpecifyField() && (
                      <div className="form-group">
                        <TextField
                          type="text"
                          label="Please Specify*"
                          value={formData.pleaseSpecify}
                          onChange={(e) =>
                            handleInputChange("pleaseSpecify", e.target.value)
                          }
                          error={!!errors.pleaseSpecify}
                        />
                        {errors.pleaseSpecify && (
                          <div className="err">{errors.pleaseSpecify}</div>
                        )}
                      </div>
                    )}

                    {formData.letUsKnowMore === "HR enquiry" && (
                      <div className="form-group full_width file_input_container">
                        <div
                          className="file_input_wrapper"
                          onClick={() => ResumeUploadClick()}
                        >
                          <input
                            type="file"
                            className="file_input"
                            ref={resumeFileInputRef}
                            onChange={handleCvUpload}
                            accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          />
                          <TextField
                            label="Upload Resume*"
                            value={cvFileName || ""}
                            InputProps={{
                              readOnly: true,
                            }}
                          />

                          <img
                            src={UploadIcon}
                            alt=""
                            className="upload-icon"
                          />
                        </div>
                        <p className="helper-text">
                          File Format : PDF, DOC, DOCX (max 5MB)
                        </p>
                        {errors.cvFile && (
                          <div className="err">{errors.cvFile}</div>
                        )}
                      </div>
                    )}

                    <div
                      className={`form-group ${
                        showBuyingProductFields() || showOtherSpecifyField()
                          ? ``
                          : `full_width`
                      } `}
                    >
                      <TextField
                        type="text"
                        label="Remarks"
                        value={formData.remarks}
                        onChange={(e) =>
                          handleInputChange("remarks", e.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="contact_btn">
                    <div className="submit_button_container">
                      <button
                        type="submit"
                        className="sanathan_submit_btn"
                        id="contactus_form_submit_btn"
                      >
                        submit
                      </button>
                      <span className="arrow">
                        <img src={coloredArrow} alt="sanathan img" />
                      </span>
                    </div>
                    <div className="reset">
                      <button
                        type="button"
                        className="sanathan_submit_btn"
                        id="contactus_form_submit_btn"
                        onClick={() => handleResetForm()}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="right">
              <div className="right_section">
                <figure>
                  <img src={bg} alt="sanathan img" />
                </figure>
                <div className="right_section_content">
                  <h3>Contact Information</h3>
                  <ul className="contact_details">
                    <li>
                      <img src={location} alt="sanathan img" />
                      <p>
                        D15, trade world, kamala mill compound, senapati bapat
                        Marg, lower Parel West Mumbai, Maharashtra 400013.
                      </p>
                    </li>
                    <li>
                      <img src={emailImg} alt="sanathan img" />
                      <a href="mailto:sales@sanathan.com" className="email">
                        sales@sanathan.com
                      </a>
                    </li>
                    {/* <li>
                                        <img src={call} alt="sanathan img"/>
                                        <a>+91 123456789</a>
                                    </li> */}
                  </ul>
                  <ul className="social_icons">
                    <li>
                      <a
                        href="https://youtube.com/channel/UCt9TLtYA5ayira8PRzXx9ig"
                        target="_blank"
                      >
                        <img src={cyoutube} alt="youtube" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/sanathantextiles/"
                        target="_blank"
                      >
                        <img src={cinstagram} alt="instagram" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.facebook.com/Sanathan-Textiles-204062499635407"
                        target="_blank"
                      >
                        <img src={cfb} alt="facebook" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://in.linkedin.com/company/sanathan-textiles-private-limited"
                        target="_blank"
                      >
                        <img src={clinkedin} alt="linkedin" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUsV2;
